import { MainHeader, MobileSearchBar } from 'Elements';
import styles from 'partials/mobile-topbar.module.scss';

export const MobileTopBar = ({ onSideTrigger, isOpenSide }) => {
	return (
		<div className={styles.box}>
			<MainHeader />
			<MobileSearchBar
				onSideTrigger={onSideTrigger}
				isOpenSide={isOpenSide}
			/>
		</div>
	);
};
